import { useRefreshCriteria } from '@/services/apis/mutations/lot-sizing/use-refresh-criteria';

type UseRefreshLotSizingCriteriaParams = {
  lotSizingId: string;
};

export function useRefreshLotSizingCriteria({
  lotSizingId,
}: UseRefreshLotSizingCriteriaParams) {
  const { mutate: refreshCriteria, isPending } = useRefreshCriteria();

  return {
    refreshCriteria: () => refreshCriteria(lotSizingId),
    isPending,
  };
}
